<template>
    <Map mapType="MAP"/>
</template>

<script>
import Map from '../components/Map.vue'

export default {
    name: 'MapMap',
    components: { Map }
};
</script>
